import { useEffect, useRef, useState } from "react";
import okxFeed from "../lib/paper/okxFeed";

// Subscribe to live OKX quotes for `symbols` (base tickers). Returns:
//   { quotes: { [base]: quote }, connected }
// Ticks are coalesced and flushed at ~`fps` (default 4) so hundreds of prints a
// second never re-render the tree more than a few times — the spec's jank guard.
export function useOkxTickers(symbols, fps = 4) {
  const [quotes, setQuotes] = useState({});
  const [connected, setConnected] = useState(false);
  const pending = useRef({});
  const key = (symbols || []).join(",");

  useEffect(() => {
    const list = (symbols || []).filter(Boolean);
    if (!list.length) return undefined;

    const off = okxFeed.onQuote((q) => {
      pending.current[q.symbol] = q;
    });
    const unsub = okxFeed.subscribe(list);

    const flush = setInterval(() => {
      setConnected(okxFeed.isConnected());
      if (Object.keys(pending.current).length) {
        const batch = pending.current;
        pending.current = {};
        setQuotes((prev) => {
          const next = { ...prev };
          for (const s of Object.keys(batch)) {
            const q = batch[s];
            const prevLast = prev[s]?.last;
            // direction of the change, for digit-flash coloring
            q.dir = prevLast == null ? 0 : q.last > prevLast ? 1 : q.last < prevLast ? -1 : 0;
            next[s] = q;
          }
          return next;
        });
      }
    }, Math.max(50, Math.round(1000 / fps)));

    return () => {
      off();
      unsub();
      clearInterval(flush);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, fps]);

  return { quotes, connected };
}

export default useOkxTickers;
